import { Card, CardButtonActionMode, HeaderGradient, MiniCard, Row } from '@app/components';
import React, { memo } from 'react';
import { theme } from '@app/theme';
import { useDynamicSizes } from '@app/hooks';
import LinearGradient from 'react-native-linear-gradient';
import { StyleSheet } from 'react-native';
import { IDeliveryZone } from '@app/common';
import { UseFormReturn, useWatch } from 'react-hook-form';

type DeliveryZoneCardProps = {
  deliveryZone?: Partial<IDeliveryZone>;
  formMethods: UseFormReturn<any, any, any>;
  toggle: (mode: CardButtonActionMode) => void;
};

const formatCardData = (partialDeliveryZone: Partial<IDeliveryZone>) => {
  return {
    name: partialDeliveryZone?.name || 'Nouvelle zone de livraison',
  }
}

export const DeliveryZoneCard = memo(({ deliveryZone, formMethods, toggle }: DeliveryZoneCardProps) => {
  const { subContainerHeight } = useDynamicSizes();

  const cardData = useWatch({
    control: formMethods.control,
  });

  const {
    name,
  } = formatCardData(cardData);

  return (
    <Card>

      <HeaderGradient>
        <LinearGradient
          start={{ x: 0.5, y: 0 }}
          end={{ x: 0.5, y: 1 }}
          locations={[0, 1]}
          colors={['rgba(253, 255, 252, 0)', 'rgba(253, 255, 252, 1)']}
          style={styles.headerGradient}
        />
      </HeaderGradient>

      <Card.TopHeader>
        <Card.TopHeaderLabel>Fiche zone de livraison</Card.TopHeaderLabel>
      </Card.TopHeader>

      <Card.Container height={subContainerHeight}>
        <Card.Background source={require('@app/assets/img/cardbackground.png')} />

        <Card.Content>
          <Card.Header>
            <Row justify="space-between" align="center">
              <Card.HeaderTitles>
                <Card.Title numberOfLines={2}>{name}</Card.Title>
                {deliveryZone?._id && <Card.Subtitle>Ref: {deliveryZone._id}</Card.Subtitle>}
              </Card.HeaderTitles>

              <Card.ButtonAction onPress={toggle} permissionScope="delivery-zones" />
            </Row>
          </Card.Header>
        </Card.Content>

        <MiniCard>
          <MiniCard.Container>
          </MiniCard.Container>
        </MiniCard>
      </Card.Container>
    </Card>
  );
});

const styles = StyleSheet.create({
  headerGradient: {
    flex: 1,
    height: theme.sizes.listHeaderHeight,
  },
});

